import React from 'react';
import {
  PRACTICE_TOPICS_LABEL,
  PRACTICE_TOPIC_TIER_PAGES,
  practiceProgressSummary,
} from '../utils/practiceTopics';

export const PRACTICE_TOPICS_BY_TIER_HEADING = `${PRACTICE_TOPICS_LABEL} by tier`;

/**
 * The Overview's "Practice Topics by tier" block, shown under "By type": a Beginnings,
 * a Foundations and a Beyond row, each opening that Practice Topics page, as the
 * "By tier" rows open the Mock Tests pages. That is how the three pages are reached on
 * a phone, where the side menu starts closed. It takes the workspace's own classes
 * (`prefix` is "ucat-ws" and so on), so its rows look exactly like the "By tier" rows.
 *
 * Beginnings counts the workspace's practice topics (and any beginnings section paper);
 * Foundations and Beyond count their section papers. `papers` is the
 * useSectionPaperTierProgress result.
 */
const PracticeTopicsOverview = ({
  prefix,
  topicsDone = 0,
  topicCount = 0,
  papers = {},
  onGo,
}) => (
  <div className={`${prefix}-section`}>
    <h2 className={`${prefix}-section-title`}>{PRACTICE_TOPICS_BY_TIER_HEADING}</h2>
    {PRACTICE_TOPIC_TIER_PAGES.map(({ page, tier, label }) => {
      const beginnings = tier === 'beginnings';
      const row = practiceProgressSummary({
        topicsDone: beginnings ? topicsDone : 0,
        topicCount: beginnings ? topicCount : 0,
        papers: papers[tier] || null,
        emptyMeta: beginnings ? 'No topics available yet' : 'No papers available yet',
      });
      return (
        <button
          key={page}
          type="button"
          className={`${prefix}-breakdown-row`}
          onClick={() => onGo(page)}
        >
          <div className={`${prefix}-breakdown-name`}>{label}</div>
          <div className={`${prefix}-breakdown-bar-wrap`}>
            <div className={`${prefix}-breakdown-bar`}>
              <div className={`${prefix}-breakdown-bar-fill`} style={{ width: `${row.pct}%` }} />
            </div>
            <div className={`${prefix}-breakdown-meta`}>{row.meta}</div>
          </div>
          <div className={`${prefix}-breakdown-score`}>{row.score}</div>
          <div className={`${prefix}-breakdown-arrow`}>›</div>
        </button>
      );
    })}
  </div>
);

export default PracticeTopicsOverview;
